/**
 * Подпись к выбору реестра: сервер отдаёт первые 100 реестров и их общее число
 * (`X-Total-Count`), остальные находятся поиском по номеру или названию. Модуль без
 * импортов значений — проверяется node:test (`registryList.test.mjs`).
 */

/** Сколько реестров отдаёт сервер без `limit` (`list_payment_registries`). */
export const REGISTRIES_PAGE = 100;

/** `null` — подпись не нужна: показаны все. */
export function registriesHint(shown: number, total: number | null, query: string): string | null {
  const q = query.trim();
  if (q && shown === 0) return `Реестров по запросу «${q}» нет`;
  if (total != null && total > shown) {
    return `Показаны первые ${shown} из ${total} — уточните поиск по номеру или названию`;
  }
  if (total == null && shown >= REGISTRIES_PAGE) {
    return `Показаны первые ${shown} — уточните поиск по номеру или названию`;
  }
  return null;
}
